<template>
  <div class="terms-card card-cell">
    <div class="card-hd">皇家行前订条款</div>
    <div class="card-bd">
      <div class="bd-box">
        <p class="title"><strong>预订须知：</strong></p>
        <p>1、 皇家行前订仅为游轮上的商品、服务和活动等(以下统称为“产品”的展示和下单平台，产品及其收款等均由游轮公司负责，所有预订订单费用将于乘客登船后自动从预订支付人(定义如下) 的船卡中扣除。</p>
        <p>2、 皇家行前订仅适用于指定的“皇家加勒比国际游轮”中国母港航次，具体以网站实时信息为准。乘客需根据船票预订信息进入皇家行前订预订产品，每艘游轮每个航次上的产品都会有所不同，乘客仅可选择与其预订航次相对应的产品进行预订。</p>
        <p>3、 皇家行前订的产品价格和优惠仅适用于行前订;乘客于登船后进行的预订，以游轮上的实际售价为准。</p>
        <p>4、 皇家行前订的产品价格和优惠会不定期进行调整，调整一般不会影响既有预订，但如修改预订订单，则预订产品的价格将以预订订单修改时本网站的实时价格和优惠为准，可能会导致原预订时享受的价格和优惠不再适用。</p>
        <p>5、 部分特殊产品因其性质或活动规则限制(例如赠品、特别限时特惠产品等)，乘客无法通过皇家行前订网站或小程序自行新增、变更或取消预订。 </p>
        <p>6、 部分产品对于乘客参与或使用有一定的限制条件（如年龄、身高、身体状况等），预订前请务必细读产品详情页面，不符合条件的客人将会被拒绝参与或使用，且不退款或更换，具体以产品下注意事项内标注为准。</p>
        <p>7、 乘客登船后未按时参与或使用产品的，均视为自动放弃已预订的产品，不予退款或更换。</p>
        <p>8、 预订支付人信息修改(如姓名、出生年月等)或预订支付人未登船会导致预订订单被自动取消，该情况下，乘客应于开航日前48小时前自行登录皇家行前订更换预订支付人，若有疑问，请拨打400-820-3187咨询专属客服。</p>
        <p>9、 产品的具体参与或使用方式请见产品详情页面，请乘客携带船卡依照详情指示方式参与或使用产品。</p>
        <p>10、完成订单后，您可以进入"我的订单“查询订单详情和产品细则。如需在皇家加勒比国际游轮APP中查看订单，请于登轮后进行。</p>
        <p>11、岸上观光产品：</p>
        <ul style="margin-left:14px;">
            <li>（1） 精品游行程的最低成团人数为38人，如未能达到最低成团人数，将于开航日前两周通知乘客；</li>
            <li>（2） 本网站提供的岸上观光产品的行程与时长等信息仅供参考，景点游览次序、停留时间等会因不可抗办、当地客流量和交通等原因有所调整，具体以地接社实际接待为准；</li>
            <li>（3） 岸上观光产品的具体集合时间、地点以及线路安排等信息将过信件方式直接放置于乘客的舱房内，乘客需于登船后自行查看舱房内的信件通知，及时获得有关信息，并按照规定的时间和地点集合。逾期不予等候、退款或更换，请乘客务必按时出席。</li>
            <li>（4） 目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
            <li>（5） 关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</li>
            <li>（6） 2025年上海出发适用于常规游行程的目的地为福冈、长崎、冲绳及釜山。</li>
        </ul>
        <p>12、 定义：</p>
        <ul style="margin-left:14px;">
            <li>（1） 预订支付人:即行前订预订订单的实际支付人，乘客在预订过程中可选择自己或同舱房其他乘客作为预订支付人，未选择的，默认为船票订单上的第一位乘客，登船后预订订单费用将自动从预订支付人的船卡中扣除。</li>
            <li>（2） 划线价：即游轮公司根据市场情况制定和建议的零售价，并非中国法律法规所定义的“原价”，且可能由游轮公司不时调整。除特别说明外，所有的立减、半价、折扣等优惠活动，均以划线价为计算基础。</li>
            <li>（3） 特惠价：特惠价为在划线价基础上减去适用或客人选用的折扣、优惠政策、优惠券叠加之后的价格。不同客人可能因为可适用或选用的折扣、优惠政策、优惠券等可以享受的优惠不同导致价格不同，以最终订单显示为准。</li>
            <li>（4） 人均特惠价：价格标注“人均”或“/人（起）”的，则该价格为在划线价基础上减去适用或客人选用的折扣、优惠政策、优惠券叠加金额之后计算人均的价格（例如"第二人半价"活动中，双人订单特惠价将由单人划线价*1.5倍计算，折合人均特惠价为划线价的75%。）人均特惠价仅为网页显示便利之目的而提供，请以最终订单显示为准。</li>
            <li>（5） 价格均未包含服务费（服务费可能因产品不同而有所不同）或其它收费或自费项目，并可能因实时库存变更、网络延迟或缓存等因素造成一定的误差，正式价格请以最终订单显示为准。</li>
        </ul>
        <p class="title"><strong>取消及修改：</strong></p>
        <p>1.   预订订单的修改或取消，仅可于开航日前48小时前进行。预订订单修改请登录皇家行前订自行操作，订单取消请拨打400-820-3187由专属客服协助操作。部分特殊产品因其性质或活动规则限制(例如赠品、特别限时特惠产品等)，乘客无法通过皇家行前订网站或小程序自行新增、变更或取消预订。</p>
        <p>2.   乘客登船后未按时参与或使用产品的，均视为自动放弃已预订的产品，不予退款或更换。</p>
        <p>3.	  部分产品会受天气、开航时间、航线变更、设施设备技术故障等影响而需取消或变更，此情况下产品取消的，工作人员将会告知乘客取消事宜，并将全额退款；产品变更的，工作人员将会告知乘客变更方案。（因产品特殊性质不同，具体以产品下注意事项内标注为准）</p>
        <p>4.	  如乘客预订的航次因不可抗力、公共卫生安全事件、政府政策、管控措施或游轮公司原因被取消，则对应的行前订预订订单自动取消，不收取取消或预订费用；如因前述原因导致乘客变更航次的，乘客可以选择保留原预订（且继续适用原预订的价格和优惠）至新的航次上，但前提是新航次上有该产品且库存充足；乘客希望保留预订的，请拨打400-820-3187 由专属客服协助操作。</p>
        <p>5.	  如乘客因其个人原因取消整个舱房的船票预订的，则对应的行前订预订订单自动取消，不收取取消或预订费用；乘客取消后重新预订船票的，需以新船票预订信息登入行前订重新进行预订。</p>
        <p>6.   皇家行前订的产品价格和优惠仅适用于行前订；乘客于登船后进行的预订，以游轮上的实际售价为准。</p>
        <p>7.	  皇家行前订的产品价格和优惠会不定期进行调整，调整一般不会影响既有预订；但如修改预订订单，则预订产品的价格将以预订订单修改时本网站的实时价格和优惠为准，可能会导致原预订时享受的价格和优惠不再适用。</p>
        <p>8.   预订支付人信息修改（如姓名、出生年月等）或预订支付人未登船会导致预订订单被自动取消，该情况下，乘客应于开航日前48小时前自行登录皇家行前订更换预订支付人，若有疑问，请拨打400-820-3187咨询专属客服。</p>
        <p>9.   预订支付人：即行前订预订订单的实际支付人，乘客在预订过程中可选择自己或同舱房其他乘客作为预订支付人，未选择的，默认为船票订单上的第一位乘客，登船后订单费用将自动从预订支付人的船卡中扣除。</p>
        <p>10.  划线价：即游轮公司根据市场情况制定和建议的零售价，并非中国法律法规所定义的“原价”，且可能由游轮公司不时调整。除特别说明外，所有的立减、半价、折扣等优惠活动，均以划线价为计算基础。</p>
        <p>11.  特惠价：特惠价为在划线价基础上减去适用或客人选用的折扣、优惠政策、优惠券叠加之后的价格。不同客人可能因为可适用或选用的折扣、优惠政策、优惠券等可以享受的优惠不同导致价格不同，以最终订单显示为准。</p>
        <p>12.  人均特惠价：价格标注“人均”或“/人（起）”的，则该价格为在划线价基础上减去适用或客人选用的折扣、优惠政策、优惠券叠加金额之后计算人均的价格（例如"第二人半价"活动中，双人订单特惠价将由单人划线价*1.5倍计算，折合人均特惠价为划线价的75%。）人均特惠价仅为网页显示便利之目的而提供，请以最终订单显示为准。</p>
        <p>13.  价格均未包含服务费（服务费可能因产品不同而有所不同）或其它收费或自费项目，并可能因实时库存变更、网络延迟或缓存等因素造成一定的误差，正式价格请以最终订单显示为准。</p>
        <p>14.  皇家加勒比国际游轮在法律允许的范围内保留对以上条款的修改及解释权。</p>
      </div>
    </div>
    <div class="card-bottom">
      <van-checkbox v-model="checked">
        我已接受以上内容条款
        <img
        slot="icon"
        :src="checked ? activeIcon : inactiveIcon"
        >
      </van-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsCard',

  props: {
    termsCheck: Boolean
  },

  data () {
    return {
      activeIcon: require('../../assets/check_ico_on.png'),
      inactiveIcon: require('../../assets/check_ico.png')
    }
  },

  computed: {
    checked: {
      get () {
        return this.termsCheck
      },
      set (val) {
        this.$emit('update:termsCheck', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.terms-card{
  .card-bd{
    padding: 30px;
    box-sizing: border-box;
    font-size: 24px;
    color: @main-gray3;
    line-height: 1.8;
    .bd-box{
      height: 5rem;
      overflow-y: auto;
      padding-right: 30px;
    }
  }
  .card-bottom{
    padding: 30px;
    font-size: 24px;
    box-shadow: 0px 0px 40px #bbbbbb;
  }
  ::-webkit-scrollbar{
    width: 4px;
  }
  ::-webkit-scrollbar-track{
    background: #eaeaea;
  }
  ::-webkit-scrollbar-thumb{
    background-color: #fbc300;
  }
}
</style>
